import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useViewModel } from "mvvm/View";
import { JobViewModel } from "../ViewModels/JobViewModel";
import ThumbsUpSolidIcon from "components/icons/actions/ThumbsUpSolidIcon";
import ThumbsDownSolidIcon from "components/icons/actions/ThumbsDownSolidIcon";
import { TagView } from "../../../assets/utilities/TagView";
import { RequestContextMenuView } from './RequestContextMenuView';
import { ConditionalTooltip } from "./ConditionalTooltip";
import { useThemeColors } from "redux/hooks";


export function JobItemView(props: { model: JobViewModel; anyContextMenuOpen: boolean; setAnyContextMenuOpen: (open: boolean) => void; indent?: boolean; tagList: string[] }) {

    const model = useViewModel(props.model);
    const themeColors = useThemeColors();

    let className = "flex-row";
    if (model.isSelected) {
        className += " selected-item";
    }

    const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0 });
    const contextMenuRef = useRef<HTMLDivElement>(null);
    const [isHovered, setIsHovered] = useState(false);
    const [isTagPopoverOpen, setIsTagPopoverOpen] = useState(false);

    const handleRightClick = useCallback((event: React.MouseEvent) => {
        event.preventDefault();
        setContextMenu({ visible: true, x: event.clientX, y: event.clientY });
        props.setAnyContextMenuOpen(true);
    }, [props]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (contextMenuRef.current && !contextMenuRef.current.contains(event.target as Node)) {
                setContextMenu({ visible: false, x: 0, y: 0 });
                props.setAnyContextMenuOpen(false); // Notify parent that context menu is closed
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [props]);

    return (
        <div onContextMenu={handleRightClick}>
            <div
                className={className}
                style={{
                    padding: "0.3em",
                    paddingLeft: props.indent ? "2.5em" : "0.3em",
                    backgroundColor: isHovered ? themeColors.hoverBackground : 'transparent',
                    borderRadius: '5px',
                    transition: 'background-color 0.2s',
                    cursor: "pointer"
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={() => model.isSelected = true}
            >
                <div onContextMenu={handleRightClick} className="flex-1" style={{
                    fontSize: "0.95em",
                    color: themeColors.textColorSecondary,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                }}>
                    <ConditionalTooltip title={model.question?.trim() || ''}>
                        <span>
                            {model.question}
                        </span>
                    </ConditionalTooltip>
                </div>
                <span style={{display: "flex", gap: "0.5em", alignItems: "center", marginLeft: "0em"}}>
                    <span
                        style={{ visibility: (model.tags && Object.keys(model.tags).length > 0) || isHovered || isTagPopoverOpen ? 'visible' : 'hidden', marginTop: "0.2em", marginBottom: "-0.2em" }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <TagView
                            model={model.tagViewModel}
                            tagList={props.tagList}
                            onOpenChange={setIsTagPopoverOpen}
                        />
                    </span>
                    {model.feedback ?
                        <ConditionalTooltip title={(model.feedback.comment || "(no comment)").trim()}>
                            <span>{model.feedback.rating === "up" ? <ThumbsUpSolidIcon /> : <ThumbsDownSolidIcon />}</span>
                        </ConditionalTooltip> :
                        null
                    }
                </span>
            </div>
            {contextMenu.visible && <RequestContextMenuView model={model} contextMenu={contextMenu} setContextMenu={setContextMenu} contextMenuRef={contextMenuRef} />}
        </div>
    )
}
